export enum ButtonSize {
    Small = 2,
    Default = 3,
}